import React,{Component} from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Modal, ModalHeader,ModalBody, Input, FormGroup, Label } from 'reactstrap';
import { isEqual } from 'lodash';
import Actions from "../../../Actions";
import { dropdownItems } from "../../../Utilities/Common";
import API from "../../../Configs";
import Permissions from "../../../Utilities/Permissions";
import Tile from "../Layout/Tile";

class AdvancedSearch extends Component{
    constructor(props){
        super(props);
        this.modalRef = false;
        this.state = {};
        this.permissions = new Permissions(props.permissions);
        this.sortOptions = [{id: "id", name: "ID"},{id:"location_id", name: "Location"},{id:"status_id", name: "Status"}, {id: "type_id", name: "Type"}, {id: "HS", name: "Health and safety"},{id: "priority", name: "Priority"}];
        this.orderOptions = [{id: "asc", name: "Ascending"},{id: "desc", name: "Descending"}];
    }

    applyFilters = () => {
        const { location_id = "", status_id = "", type_id = "", HS = "", priority = "", assigned_to = "", sort = "", order = "" } = this.state;
        const query = {page: 1, location_id, status_id, type_id, HS, priority, assigned_to, sort, order};
        const { refresh, token, toggleModal } = this.props;
        refresh(token,query);
        toggleModal("jobs","search");
    }

    setField = (endpoint,option,type = 0) => {
        const dataObj = {};
        const { target } = option;
        switch(type){
            case 0:
                dataObj[endpoint] = target.value;
                break;
            case 1:
                dataObj[endpoint] = target.checked ? 1 : 0;
                break;
        }
        //if(endpoint === "location"){dataObj.subLocations = this.state.locations[target.value].sub_locations;}
        this.setState((state) => (dataObj));
    }

    loadUsers = () => {
        const { token, userStore, getUsers} = this.props;
        const query = { page:1, sort: 'name', order: 'asc', per_page: 1000};
        if(!isEqual(userStore.query,query)){
            getUsers(token,query);
        }
    }

    loadLocations = () => {
        const { token, locationStore, getLocations } = this.props;
        const query = { page:1, sort: 'name', order: 'asc', per_page: 1000};
        if(!isEqual(locationStore.query,query)){
            getLocations(token,query);
        }
    }

    loadTypes = () => {
        const { token, typeStore, getTypes } = this.props;
        const query = { page:1, sort: 'name', order: 'asc', per_page: 1000};
        if(!isEqual(typeStore.query,query)){
            getTypes(token,query);
        }
    }

    componentWillMount(){
        this.loadLocations();
        this.loadTypes();
        this.loadUsers();
    }

    render = () => {
        const { locationStore, typeStore, userStore, modalStore: { search: { modal }}, toggleModal } = this.props;
        const { location_id = "", status_id = "", type_id = "", HS = "", priority = "", assigned_to = "", sort = "", order = "" } = this.state;
        const statuses = API.STATUSES;
        const { blockedField } = this.permissions;

        return (
            <div>
                <Modal size="lg" isOpen={modal} toggle={() => toggleModal("jobs","search")}>
                    <ModalHeader toggle={() => toggleModal("jobs","search")}>Advanced Search</ModalHeader>
                    <ModalBody style={{backgroundColor:"#f2f2f2"}}>
                        <div ref={(ref) => this.modalRef = ref}>    
                            <Tile xs="11" style={{marginTop:15,paddingTop:15,backgroundColor:"#fff"}} className="shadow-sm rounded mx-auto">
                                <Row>
                                    <Col xs="12" md="6">
                                        <FormGroup>
                                            <Label>
                                                Job Type
                                            </Label>
                                            <Input onChange={(value) => this.setField("type_id",value)} defaultValue={type_id} type="select">{dropdownItems(typeStore.types)}</Input>
                                        </FormGroup>
                                        </Col>
                                        <Col xs="12" md="6">
                                        <FormGroup>
                                            <Label>
                                                Location
                                            </Label>
                                            <Input onChange={(value) => this.setField("location_id",value)} defaultValue={location_id} type="select">{dropdownItems(locationStore.locations)}</Input>
                                        </FormGroup>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <FormGroup>
                                            <Label>
                                                Status
                                            </Label>
                                            <Input onChange={(value) => this.setField("status_id",value)} defaultValue={status_id} type="select">{dropdownItems(statuses)}</Input>
                                        </FormGroup>
                                    </Col>
                                    {!blockedField("assigned_to","jobs") ?
                                    <Col xs="12" md="6">
                                        <FormGroup>
                                            <Label>
                                                Assigned To
                                            </Label>
                                            <Input type="select" onChange={(value) => this.setField("assigned_to",value)} defaultValue={assigned_to}>{dropdownItems(userStore.users)}</Input>                            
                                        </FormGroup>
                                    </Col>
                                    :null}
                                    <Col xs="12" md="6">
                                        <FormGroup>
                                            <Label>
                                                Sort by
                                            </Label>
                                            <Input type="select" onChange={(value) => this.setField("sort",value)} defaultValue={sort}>{dropdownItems(this.sortOptions)}</Input>                            
                                        </FormGroup>
                                    </Col>
                                    <Col xs="12" md="6">
                                        <FormGroup>
                                            <Label>
                                                Order
                                            </Label>
                                            <Input type="select" onChange={(value) => this.setField("order",value)} defaultValue={order}>{dropdownItems(this.orderOptions)}</Input>                            
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="6">
                                        <FormGroup check>
                                            <Label check>
                                            <Input type="checkbox" onChange={(value) => this.setField("priority",value,1)} checked={priority === 1 ? true : false}/>
                                                High Priority
                                            </Label>
                                            <br/>                                
                                        </FormGroup>
                                    </Col>
                                    <Col xs="6">
                                        <FormGroup check>
                                            <Label check>
                                            <Input type="checkbox" onChange={(value) => this.setField("HS",value,1)} checked={HS === 1 ? true : false}/>  {' '}
                                                H&S
                                            </Label>
                                            <br/><br/>
                                        </FormGroup>                 
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="12">
                                        <FormGroup>
                                            <Button onClick={this.applyFilters} color="success" kind="squared">Search</Button>                           
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Tile>
                        </div>
                    </ModalBody>
                </Modal>
            </div>                            
        );
    }
}

const mapStateToProps = (state) => ({
    permissions: state.auth.permissions,
    token: state.auth.token,
    typeStore: state.typeStore,
    locationStore: state.locationStore,
    userStore: state.userStore,
    modalStore: state.modalStore.jobs,
    query: state.jobStore.query,
});

const { types, locations, jobs, users, modals } = Actions;

export default connect(mapStateToProps, {...types, ...locations, ...jobs, ...users, ...modals})(AdvancedSearch);


// WEBPACK FOOTER //
// ./src/Components/App/Jobs/AdvancedSearch.js